<app-screen-content [isLoading]="model.isLoading">
  <ng-container title>
    <img src="assets/icons/ic-recommended@3x.svg" alt="" />
    <span>Recommended products</span>
  </ng-container>

  <div body>
    <div class="box" style="margin-bottom: 20px">
      <p class="table-title">Table A: Recommended products</p>
      <p class="table-description">
        These products have been recommended to your organisation based on the
        information you have provided in this FNA. Any inaccurate or incomplete
        information will affect the suitability of the advice and/or
        recommendations.
      </p>
      <div class="blue-link" (click)="showRecommendedProduct()">
        View detailed product descriptions
      </div>
      <div class="risk-section">
        <p class="section-title">Low risk</p>
        <div *ngFor="let option of lowRiskOption" class="managed-content">
          <app-checkbox
            [label]="option.title"
            [description]="option.shortDescription"
            [value]="option.title.toLowerCase().includes('others')?option.isChecked:true"
            [disabled]="true"
            [name]="'' + option.id"
          ></app-checkbox>
        </div>
      </div>
      <div
        class="risk-section"
        *ngIf="
          model.assessedRiskProfile === riskLevel.MODERATE ||
          model.assessedRiskProfile === riskLevel.AGGRESSIVE
        "
      >
        <p class="section-title">Moderate risk</p>
        <div *ngFor="let option of moderateRiskOption" class="managed-content">
          <app-checkbox
            [label]="option.title"
            [description]="option.shortDescription"
            [value]="option.title.toLowerCase().includes('others')?option.isChecked:true"
            [disabled]="true"
            [name]="'' + option.id"
          ></app-checkbox>
        </div>
      </div>
      <div
        class="risk-section"
        *ngIf="model.assessedRiskProfile === riskLevel.AGGRESSIVE"
      >
        <p class="section-title">High risk</p>
        <div *ngFor="let option of highRiskOption" class="managed-content">
          <app-checkbox
            [label]="option.title"
            [description]="option.shortDescription"
            [value]="option.title.toLowerCase().includes('others')?option.isChecked:true"
            [disabled]="true"
            [name]="'' + option.id"
          ></app-checkbox>
        </div>
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="this.onSubmit()">
      <div class="box">
        <div class="sub-box">
          <p class="table-title">Table B: Non-recommended products</p>
          <p class="table-description">
            These products that are beyond your assessed risk profile are also
            available to you, but will be purchased at your own risk
          </p>
          <div class="blue-link" (click)="showNonRecommendedProduct()">
            View detailed product descriptions
          </div>
        </div>

        <div>
          <div class="question-title">
            Do you accept the recommended products in Table A?
          </div>
          <div class="row radio-row">
            <div class="col-lg-6">
              <app-radio
                label="Yes"
                [radioValue]="true"
                [value]="isAcceptRecommendedProductsControl.value"
                name="isAcceptRecommendedProducts"
                formControlName="isAcceptRecommendedProducts"
                description="We accept the recommendation of the selected products set out in Table A"
                (click)="isAcceptRecommendedProductsOptionClick($event, true)"
              ></app-radio>
            </div>
            <div class="col-lg-6">
              <app-radio
                label="No"
                [radioValue]="false"
                [value]="isAcceptRecommendedProductsControl.value"
                name="isAcceptRecommendedProducts"
                formControlName="isAcceptRecommendedProducts"
                description="We do not wish to accept recommendation of the selected product set out in Table A. Instead, we wish to purchase non-recommended products in Table B"
                (click)="isAcceptRecommendedProductsOptionClick($event, false)"
              ></app-radio>
            </div>
          </div>
          <div
            *ngIf="
              model.shouldShowErrors &&
              isAcceptRecommendedProductsControl.errors?.required
            "
            class="error fna-mt-10"
          >
            <p>Please select an option</p>
          </div>
        </div>

        <div
          *ngIf="isAcceptRecommendedProductsControl.value === true"
          class="radio-section"
        >
          <div class="question-title">
            Do you also wish to purchase other products in Table B?
          </div>
          <div class="row radio-row">
            <div class="col-lg-6">
              <app-radio
                label="Yes"
                [radioValue]="true"
                [value]="isPurchaseTableBProductsControl.value"
                name="isPurchaseTableBProducts"
                formControlName="isPurchaseTableBProducts"
                description="We also wish to purchase other products that are not recommended in Table B"
                (click)="isPurchaseTableBProductsOptionClick($event, true)"
              ></app-radio>
            </div>
            <div class="col-lg-6">
              <app-radio
                label="No"
                [radioValue]="false"
                [value]="isPurchaseTableBProductsControl.value"
                name="isPurchaseTableBProducts"
                formControlName="isPurchaseTableBProducts"
                description="We do not wish to purchase other products which are not recommended"
                (click)="isPurchaseTableBProductsOptionClick($event, true)"
              ></app-radio>
            </div>
          </div>
          <div
            *ngIf="
              isAcceptRecommendedProductsControl.value === true &&
              model.shouldShowErrors &&
              isPurchaseTableBProductsControl.errors?.required
            "
            class="error fna-mt-10"
          >
            <p>Please select an option</p>
          </div>
        </div>
      </div>
      <div class="bottom-nav">
        <app-back-button (click)="goToPreviousScreen()"></app-back-button>
        <app-next-button buttonType="submit"></app-next-button>
      </div>
    </form>

    <ng-template #confirmationModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Attention</h4>
      </div>
      <div class="modal-body">
        Your current inputs will be cleared. Would you like to continue?
      </div>
      <div class="modal-footer">
        <app-primary-button
          buttonType="button"
          [outline]="true"
          (click)="modal.dismiss()"
        >
          No
        </app-primary-button>
        <app-primary-button buttonType="button" (click)="modal.close('save')">
          Yes
        </app-primary-button>
      </div>
    </ng-template>

    <div *ngIf="globals.isDebug" class="mt56">
      <h3>Information for developers, please ignore</h3>
      <h4>Data</h4>
      <pre class="debug-log-mono">{{ model.data | json }}</pre>
      <h4>Model</h4>
      <h5>Recommended Products</h5>
      <pre class="debug-log-mono">{{
        model.isAcceptRecommendedProducts | json
      }}</pre>
      <h5>Form value</h5>
      <pre class="debug-log-mono">{{ form.value | json }}</pre>
    </div>
  </div>
</app-screen-content>
